import * as Yup from 'yup';

export const PASSWORD_POLICY_MESSAGE =
  'A senha deve ter pelo menos 8 caracteres, uma letra maiúscula, uma letra minúscula, um número e um caractere especial';

export const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

export const passwordField = Yup.string()
  .required('Este campo é obrigatório!')
  .matches(PASSWORD_PATTERN, PASSWORD_POLICY_MESSAGE);

export const passwordConfirmationField = Yup.string()
  .required('Este campo é obrigatório!')
  .oneOf([Yup.ref('new_password'), null], 'A confirmação da senha não confere');
